import React, { useEffect, useRef, useState } from "react";
import { CONTINENTS } from "../../lib/tour";
import { TourLocation } from "./TourLocation";
import { TourAmbience } from "./TourAmbience";
import { TourAirport, TourPlanes } from "./TourAirport";

const SAMPLE_W = 454;
const SAMPLE_H = 203;

function useAlphaMaps() {
  const maps = useRef({});
  useEffect(() => {
    CONTINENTS.forEach((c) => {
      const img = new Image();
      img.onload = () => {
        const cv = document.createElement("canvas");
        cv.width = SAMPLE_W;
        cv.height = SAMPLE_H;
        const ctx = cv.getContext("2d", { willReadFrequently: true });
        ctx.drawImage(img, 0, 0, SAMPLE_W, SAMPLE_H);
        maps.current[c.id] = ctx.getImageData(0, 0, SAMPLE_W, SAMPLE_H).data;
      };
      img.src = c.src;
    });
  }, []);
  return maps;
}

export function TourMap({ state, floats, pops, selectedId, onDropWrestler, onClickLocation, onDragStartPlaced }) {
  const maps = useAlphaMaps();
  const [hover, setHover] = useState(null);

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    const x = Math.floor(((e.clientX - r.left) / r.width) * SAMPLE_W);
    const y = Math.floor(((e.clientY - r.top) / r.height) * SAMPLE_H);
    let hit = null;
    for (let i = CONTINENTS.length - 1; i >= 0 && !hit; i--) {
      const d = maps.current[CONTINENTS[i].id];
      if (d && d[(y * SAMPLE_W + x) * 4 + 3] > 60) hit = CONTINENTS[i].id;
    }
    if (hit !== hover) setHover(hit);
  };

  const byId = Object.fromEntries((state.assigned || []).map((w) => [w.wrestler_id, w]));

  return (
    <div data-testid="tour-map" className="relative w-full select-none" style={{ aspectRatio: "1815 / 813" }}
         onMouseMove={onMove} onMouseLeave={() => setHover(null)}>
      {CONTINENTS.map((c, i) => (
        <React.Fragment key={c.id}>
          <img src={c.src} alt="" draggable={false} aria-hidden="true"
               className="tour-continent-glow absolute inset-0 w-full h-full pointer-events-none"
               style={{ filter: `blur(10px) brightness(1.7) drop-shadow(0 0 6px ${c.color})`, animationDelay: `${i * 1.1}s` }} />
          <img src={c.src} alt={c.id} draggable={false} data-testid={`tour-continent-${c.id}`}
               data-hovered={hover === c.id ? "true" : "false"}
               className="absolute inset-0 w-full h-full pointer-events-none transition-[filter,transform] duration-300"
               style={hover === c.id ? { filter: `brightness(1.35) saturate(1.2) drop-shadow(0 0 14px ${c.color})`, transform: "scale(1.004)" } : undefined} />
        </React.Fragment>
      ))}
      <TourAmbience locations={state.locations} airport={state.airport} />
      {state.airport && <TourAirport airport={state.airport} planes={state.planes || []} />}
      <TourPlanes airport={state.airport} planes={state.planes || []} locations={state.locations} />
      {(state.locations || []).map((loc) => {
        const w = loc.wrestler_id ? byId[loc.wrestler_id] : null;
        return (
          <TourLocation key={loc.id} loc={loc} wrestler={w}
                        floats={floats[loc.id] || []} pops={(w && pops[w.wrestler_id]) || null} armed={!!selectedId}
                        selected={!!w && w.wrestler_id === selectedId}
                        onDrop={(wid) => onDropWrestler(wid, loc.id)} onClick={() => onClickLocation(loc)}
                        onDragStartPlaced={onDragStartPlaced} />
        );
      })}
    </div>
  );
}
